import { useState } from "react";

function ImportModal({ setShowModal, downloadExcel, handleFileUpload, type, importRowsLimit }) {
    const [fileName, setFileName] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [error, setError] = useState(null);

    const onSubmit = () => {
        if (!selectedFile) {
            setError("Please upload a file")
            return
        }
        handleFileUpload(selectedFile);
        setShowModal(false);
    };


    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-emerald-900/40 backdrop-blur-sm px-3 sm:px-4 py-6">
            <div className="w-full max-w-2xl rounded-3xl border border-emerald-100 bg-white shadow-[0_18px_48px_rgba(15,118,110,0.15)] p-6 sm:p-7 max-h-[90vh] overflow-y-auto">
                <div className="flex flex-col gap-6">
                    <div className="rounded-2xl border border-emerald-100 bg-emerald-50/60 p-2 text-sm text-emerald-800 leading-relaxed">
                        <div className="flex flex-row justify-between">
                            <p className="font-semibold mb-3 text-emerald-700">Import instructions</p>
                            <header className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                                <button
                                    type="button"
                                    onClick={downloadExcel}
                                    className="inline-flex items-center justify-center rounded-full border border-emerald-200 px-4 py-2 text-sm font-semibold text-emerald-700 hover:bg-emerald-50 transition-colors"
                                >
                                    Download sample Excel
                                </button>
                            </header>
                        </div>
                        <ul className="list-disc list-inside space-y-2">
                            <li>Excel file can only include up to <span className="font-semibold">{importRowsLimit}</span> rows per upload.</li>
                            {type === "car" && (
                                <>
                                    <li>Date columns must follow the <span className="font-semibold">mm/dd/yyyy</span> format.</li>
                                    <li>
                                        Allowed values:
                                        <ul className="list-disc list-inside ml-5 space-y-1 text-emerald-700">
                                            <li><span className="font-semibold">odo_unit:</span> mi, km</li>
                                            <li><span className="font-semibold">fuel_type:</span> Gasoline, Diesel, Electric, Hybrid, Other</li>
                                            <li><span className="font-semibold">ownership:</span> Owned, Leased, Rented</li>
                                            <li><span className="font-semibold">transmission:</span> Auto, Manual, CVT</li>
                                            <li><span className="font-semibold">drivetrain:</span> FWD, RWD, AWD, 4WD</li>
                                        </ul>
                                    </li>
                                </>
                            )}
                            {type === "customer" && (
                                <>
                                    <li><span className="font-semibold">creditLimit</span> is the pre-approved spend (USD) for the customer.</li>
                                    <li><span className="font-semibold">maxDiscount</span> is the maximum technician discount (%).</li>
                                    <li>
                                        Allowed values:
                                        <ul className="list-disc list-inside ml-5 space-y-1 text-emerald-700">
                                            <li><span className="font-semibold">bypassApproval:</span> yes, no</li>
                                            <li><span className="font-semibold">country:</span> US, CANADA</li>
                                            <li><span className="font-semibold">paymentTerms:</span> Net 7, Net 10, Net 30, Net 45, Net 60, Net 90, On Receipt</li>
                                        </ul>
                                    </li>
                                </>
                            )}
                        </ul>
                    </div>

                    <label
                        htmlFor="excel-upload"
                        className="flex flex-col items-center justify-center gap-2 rounded-2xl border-2 border-dashed border-emerald-200 bg-white px-6 py-2 text-center text-emerald-700 cursor-pointer transition-colors hover:border-emerald-400 hover:bg-emerald-50"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-emerald-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 16V4m0 12 3-3m-3 3-3-3M6 20h12" />
                        </svg>
                        <div className="text-base font-semibold">Drop your Excel file here</div>
                        <div className="text-xs text-emerald-500">Supports .xlsx and .xls</div>
                        <input
                            id="excel-upload"
                            type="file"
                            accept=".xlsx,.xls"
                            className="hidden"
                            onChange={(e) => {
                                const file = e.target.files?.[0];
                                if (file) {
                                    setSelectedFile(file);
                                    setFileName(file.name);
                                    setError(null);
                                }
                            }}
                        />
                    </label>

                    {fileName && (
                        <div className="flex items-center justify-between rounded-full border border-emerald-100 bg-emerald-50 px-4 py-2 text-sm text-emerald-700">
                            <span className="font-medium truncate">{fileName}</span>
                            <button
                                type="button"
                                className="text-emerald-500 font-semibold hover:text-emerald-700"
                                onClick={() => {
                                    setFileName("");
                                    setSelectedFile(null);
                                }}
                            >
                                Clear
                            </button>
                        </div>
                    )}

                    {error && (
                        <div className="rounded-xl border border-red-200 bg-red-50 px-4 py-2 text-sm text-red-600">
                            {error}
                        </div>
                    )}

                    <div className="flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
                        <button
                            type="button"
                            className="inline-flex items-center justify-center rounded-full border border-emerald-200 px-5 py-2 text-sm font-semibold text-emerald-700 hover:bg-emerald-50 transition-colors"
                            onClick={() => setShowModal(false)}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="inline-flex items-center justify-center rounded-full bg-emerald-600 px-5 py-2 text-sm font-semibold text-white shadow-[0_10px_25px_rgba(16,185,129,0.25)] transition-colors hover:bg-emerald-700"
                            onClick={onSubmit}
                        >
                            Upload file
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ImportModal;
